exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".blog-cls-1,.blog-cls-2{fill:none}.blog-cls-3{fill:#005f84}.blog-cls-7{fill:#abdfda}.blog-cls-8{fill:#cce5ee}.blog-cls-12{fill:#292929}.blog-cls-13{fill:#288980}.blog-cls-14{fill:#5dc2b8}.blog-cls-2{stroke:#288980;stroke-miterlimit:10;stroke-width:.35px}", ""]);

